module.exports = __webpack_public_path__ + "img/chinesecompany168.88eaab88.png";